import Team from 'Containers/Team';

export default Team;
